
	import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			max: Number,
			step: {
				type: Number,
				default: 0,
			},
			message: String,
		},
	});
